<template>
  <div class="container">
    <div class="header">
      <van-nav-bar title="日报总览" @click-left="handleBack">
        <template #left>
          <van-icon name="arrow-left" size="0.533rem" color="#333333" />
        </template>
      </van-nav-bar>
      <div class="company_selection" @click="selectCompanyHandler">
        <span>{{ companyName }}</span>
        <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
      </div>
      <div class="search_tab">
        <div :class="[type == 1 ? 'active' : '']" @click="type = 1" style=" border-radius:4px 0px 0px 4px;border:1px solid;">全部</div>
        <div :class="[type == 2 ? 'active' : '']" @click="type = 2" style="border:1px solid;border-left: none;">已完成</div>
        <div :class="[type == 3 ? 'active' : '']" @click="type = 3" style="border:1px solid;border-left: none;border-right: none;">未完成</div>
        <div @click="type = 4" :class="[type == 4 ? 'active' : '']" style="border:1px solid;border-color:#1584ff;border-radius:0px 4px 4px 0px;">
          补交
        </div>
      </div>
      <div class="report_search">
        <div
          style="display:flex;
          align-items: center;
          border:1px solid;
          height: 26px;
          border-color:#dddddd;
          border-radius:4px;
          padding: 4px;"
          @click="showSelectDate"
        >
          <div>{{ currentDate }}</div>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
        <div class="end_date">数据截止时间：{{ currentDateStr }}</div>
      </div>
      <van-search v-model="searchValue" clearable show-action placeholder="请输入姓名查询">
        <template #action>
          <div @click="onSearch">查询</div>
        </template>
      </van-search>
    </div>
    <div class="daily_content">
      <div class="show_Statistic">
        <div
          style="font-family:Source Han Sans CN;
          color:#666666;
          font-size:12px;
          display: flex;
          align-items: center;"
        >
          <span>全部</span><span style="padding-left: 4px">{{ overviewData.shouldSubmitTotalNum || 0 }}</span
          ><span style="margin: 0 4px">|</span> <span>已完成</span><span style="padding-left: 4px">{{ overviewData.submittedTotalNum || 0 }}</span
          ><span style="margin: 0 4px">|</span> <span>未完成</span><span style="padding-left: 4px">{{ overviewData.unSubmittedTotalNum || 0 }}</span>
        </div>
        <div style="display:flex;padding-right: 16px;align-items:center">
          <van-checkbox
            style="
            background-color:#ffffff;
            margin-right: 4px;
            border-radius:2px;"
            shape="square"
            v-model="showQuit"
            @change="onSearch"
          />
          <div>仅显示离职人员</div>
        </div>
      </div>
      <div v-if="dateType == 'day'">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item, index) in dailyList" class="daily_item" :key="index" @click="toStaffMonthDetail(item)">
              <!-- <div> -->
              <img style="" v-if="item.avatar" :src="item.avatar" class="member_img" />
              <img style="" v-else src="@/assets/default.png" class="member_img" />
              <!-- </div> -->
              <span
                style="width:70px;
                font-family:Source Han Sans CN;
                color:#333333;
                font-size:14px;
                display: inline-block;
                white-space:nowrap; 
                text-overflow:ellipsis;
                "
                >{{ item.staffName.slice(0, 5) }}</span
              >
              <span
                v-if="item.supplementFlag == 0"
                style="display:inline-block;
                width:46px;
                height:20px;
                border:1px solid;
                border-color:#ffba19;
                border-radius:11.5px;
                font-family:Source Han Sans CN;
                color:#ffba19;
                font-size:13px;
                text-align: center;
                line-height: 20px"
                >补交</span
              >
              <span
                v-if="item.jobStatus == '1'"
                style="font-family:Source Han Sans CN;
                color:#fe5208;
                font-size:13px;"
                >已离职，最后工作日</span
              >
              <span
                v-if="item.reportStatus == '请假'"
                style="font-family:Source Han Sans CN;
                color:#ffba19;
                font-size:13px;"
                >全天请假，不需要写日报</span
              >
              <span style=";position: absolute;right:20px;top: 7px" v-if="item.reportStatus != '补交' && item.reportStatus != '请假' && item.jobStatus != '1'">{{
                item.reportStatus
              }}</span>
              <img
                v-if="item.reportStatus != '未提交' && item.reportStatus != '请假'"
                style="width: 20px;height: 20px;position: absolute;right:-5px;top: 9px"
                src="@/assets/right.png"
              />
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
      <div v-else>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <van-cell v-for="(item, index) in dailyList" class="daily_item" :key="index" @click="toStaffMonthDetail(item)">
              <img style="margin-left: 6px" v-if="item.avatar" :src="item.avatar" class="member_img" />
              <img style="margin-left: 6px" v-else src="@/assets/default.png" class="member_img" />
              <span
                style="width:70px;
                font-family:Source Han Sans CN;
                color:#333333;
                font-size:14px;
                display: inline-block;
                white-space:nowrap; 
                text-overflow:ellipsis;"
                >{{ item.staffName.slice(0, 5) }}</span
              >
              <span style="margin-left: 6px;line-height: 1rem;">已提交：{{ item.submittedNum }}</span>
              <span style="margin-left: 6px;line-height: 1rem;">应提交：{{ item.shouldSubmitNum }}</span>
              <span
                v-if="item.supplementNum > 0"
                style="margin-left: 6px;line-height: 1rem;width:45px;
                height:13px;
                font-family:Source Han Sans CN;
                color:#ffba19;
                font-size:13px;
                line-height:13px;"
                >补交：{{ item.supplementNum }}</span
              >
              <img style="width: 20px;height: 20px;position: absolute;right:-5px;top: 9px" src="@/assets/right.png" />
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <van-popup v-model="showMonthPicker" position="bottom">
      <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" @confirm="(data) => onMonthConfirm(data)" @cancel="showMonthPicker = false" />
    </van-popup>
    <van-action-sheet v-model="showDatePicker">
      <van-datetime-picker
        v-model="selectedDate"
        :type="dateType == 'day' ? 'date' : 'year-month'"
        :formatter="formatter"
        title="选择年月"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import {
  getReportStatisticsOverViewDetailByMonth,
  getReportStatisticsOverViewDetailByDate,
  getReportStatisticsOverViewNumByDate,
  getReportStatisticsOverViewNumByMonth,
} from "@/axios/services";
import { mapState, mapMutations } from "vuex";
import dayjs from "dayjs";
// import VeiBanBridge from "@/utils/bridge";
import { Toast } from "vant";
export default {
  data() {
    return {
      type: 1,
      dateType: "",
      showMonthPicker: false,
      showDatePicker: false,
      currentDateStr: this.getDate("yyyy-MM-dd", "yesterday"),
      currentDate: "",
      // currentMonthStr: this.getCurrentMonth(new Date()),
      selectedDate: "",
      searchValue: "",
      showQuit: false,
      loading: false,
      finished: false,
      refreshing: false,
      dailyList: [],
      currentPage: 1,
      currentPageSize: 10,
      companyId: "",
      officeId: "",
      overviewData: {},
      selectedCompany: [],
      companyName: "",
      companyInfo: {},
      scopeType: "",
    };
  },
  watch: {
    type(newValue, oldValue) {
      if (newValue) {
        this.currentPage = 1;
        this.dailyList = [];
        this.onRefresh();
        this.getOverviewData();
      }
    },
  },
  computed: {
    ...mapState(["initialData", "fromApp"]),
  },
  methods: {
    getDate(format = "yyyy-MM-dd", type) {
      let date = null;
      type = type || "today";
      let now = +Date.now();
      let oneDay = 1000 * 60 * 60 * 24;
      let yesterday = now - oneDay;
      const typeDes = ["yesterday", "today"];
      if (typeDes.includes(type)) {
        date = type === "yesterday" ? new Date(yesterday) : new Date();
      } else {
        date = new Date(type);
      }
      if (date.toString() === "Invalid Date") {
        return;
      }
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
    handleBack() {
      this.$router.back();
    },
    selectCompanyHandler() {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany),
        },
      });
    },
    onSearch() {
      this.currentPage = 1;
      this.dailyList = [];
      this.onRefresh();
    },
    // changeMonth() {
    //   this.showMonthPicker = true;
    // },
    getCurrentMonth(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1);
    },
    getCurrentDay(date) {
      return date.getFullYear() + "-" + this.checkTime(date.getMonth() + 1) + "-" + this.checkTime(date.getDate());
    },
    // onMonthConfirm(date) {
    //   this.currentMonthStr = this.getCurrentMonth(date);
    //   this.showMonthPicker = false;
    // },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else {
        return `${val}日`;
      }
    },
    showSelectDate() {
      this.showDatePicker = true;
    },
    dateConfirm() {
      this.showDatePicker = false;
      this.currentDate = this.dateType === "day" ? dayjs(this.selectedDate).format("YYYY-MM-DD") : dayjs(this.selectedDate).format("YYYY-MM");
      this.currentPage = 1;
      this.dailyList = [];
      this.onRefresh();
      this.getOverviewData();
    },
    checkTime(i) {
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.currentPage = 1;
      this.onLoad();
    },
    onLoad() {
      this.getData();
    },
    getReportStatisticsOverViewDetailByMonth() {
      const params = {
        companyId: this.companyId,
        officeId: this.officeId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        // jobStatus: this.showQuit ? "1" : "",
        reportMonth: this.currentDate,
        reportStatus: this.type == 1 ? "" : this.type == 2 ? "finish" : this.type == 3 ? "unfinish" : "supplement",
        staffName: this.searchValue,
      };
      if (this.showQuit) {
        params.jobStatus = 1;
      }
      if (this.scopeType == 0) {
        params.blocFlag = "Y";
      }
      getReportStatisticsOverViewDetailByMonth(params).then((res) => {
        if (res.data.code === 0) {
          let { records, total } = res.data.data;
          this.currentPage++;
          this.loading = false;
          if (this.refreshing) {
            this.dailyList = [];
            this.refreshing = false;
          }
          if (this.dailyList.length === 0) {
            this.dailyList = records;
          } else {
            this.dailyList = this.dailyList.concat(records);
          }
          if (this.dailyList.length >= total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      });
    },
    toStaffMonthDetail(item) {
      if (this.dateType === "day") {
        if (item.reportStatus == "未提交" || item.reportStatus == "休息") {
          return Toast.fail("该状态无法查看日报");
        }
        const params = {
          staffId: item.staffId,
          staffName: item.staffName,
          reportDate: item.reportDate,
          type: this.dateType,
        };
        this.$router.push({
          path: "/daily-month",
          query: {
            ...params,
          },
        });
      } else {
        const params = {
          staffId: item.staffId,
          staffName: item.staffName,
          reportMonth: item.reportMonth,
          type: this.dateType,
        };
        this.$router.push({
          path: "/daily-month",
          query: {
            ...params,
          },
        });
      }
    },
    getReportStatisticsOverViewDetailByDate() {
      const params = {
        companyId: this.companyId,
        officeId: this.officeId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        // reportMonth: this.dateType === "day" ? '' : this.currentDate,
        reportDate: this.currentDate,
        // jobStatus: this.showQuit ? 1 : ,
        reportStatus: this.type == 1 ? "" : this.type == 2 ? "finish" : this.type == 3 ? "unfinish" : "supplement",
        staffName: this.searchValue,
      };
      if (this.showQuit) {
        params.jobStatus = 1;
      }
      if (this.scopeType == 0) {
        params.blocFlag = "Y";
      }
      getReportStatisticsOverViewDetailByDate(params).then((res) => {
        if (res.data.code === 0) {
          let { records, total } = res.data.data;
          this.currentPage++;
          this.loading = false;
          if (this.refreshing) {
            this.dailyList = [];
            this.refreshing = false;
          }
          if (this.dailyList.length === 0) {
            this.dailyList = records;
          } else {
            this.dailyList = this.dailyList.concat(records);
          }
          if (this.dailyList.length >= total) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        }
      });
    },
    getReportStatisticsOverViewNumByDate() {
      const params = {
        companyId: this.companyId,
        officeId: this.officeId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        // reportMonth: this.dateType === "day" ? '' : this.currentDate,
        reportDate: this.currentDate,
        // jobStatus: this.showQuit ? 1 : ,
        reportStatus: this.type == 1 ? "" : this.type == 2 ? "finish" : this.type == 3 ? "unfinish" : "supplement",
        staffName: this.searchValue,
      };
      if (this.showQuit) {
        params.jobStatus = 1;
      }
      if (this.scopeType == 0) {
        params.blocFlag = "Y";
      }
      getReportStatisticsOverViewNumByDate(params).then((res) => {
        if (res.data.code === 0) {
          this.overviewData = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    getReportStatisticsOverViewNumByMonth() {
      const params = {
        companyId: this.companyId,
        officeId: this.officeId,
        currentPage: this.currentPage,
        currentPageSize: this.currentPageSize,
        // jobStatus: this.showQuit ? "1" : "",
        reportMonth: this.currentDate,
        reportStatus: this.type == 1 ? "" : this.type == 2 ? "finish" : this.type == 3 ? "unfinish" : "supplement",
        staffName: this.searchValue,
      };
      if (this.showQuit) {
        params.jobStatus = 1;
      }
      if (this.scopeType == 0) {
        params.blocFlag = "Y";
      }
      getReportStatisticsOverViewNumByMonth(params).then((res) => {
        if (res.data.code === 0) {
          this.overviewData = res.data.data;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    getData() {
      if (this.dateType === "day") {
        this.getReportStatisticsOverViewDetailByDate();
      } else {
        this.getReportStatisticsOverViewDetailByMonth();
      }
    },
    getOverviewData() {
      if (this.dateType === "day") {
        this.getReportStatisticsOverViewNumByDate();
      } else {
        this.getReportStatisticsOverViewNumByMonth();
      }
    },
    getYesterday() {
      let day = new Date();
      day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
      this.selectedDate = day;
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   if (from.path === "/select-data-range") {
  //     let params = from.params?.selectedData || [];
  //     next((vm) => {
  //       if (params.length) {
  //         vm.selectedCompany = params;
  //         let selected = params[params.length - 1];
  //         vm.companyName = selected.name;
  //         vm.scopeType = selected.type;
  //         vm.companyId = selected.companyId;
  //         vm.officeId = selected.officeId;
  //       }
  //     });
  //   } else {
  //     next();
  //   }
  // },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/select-data-range" || from.path === "/personal-report-board") {
      let params = null;
      let selcetDate = "";
      if (from.path === "/select-data-range") {
        params = from.params?.selectedData || [];
      } else if (from.path === "/personal-report-board") {
        params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : [];
        selcetDate = to.query?.selectionDate;
      }
      next((vm) => {
        // vm.seletionDateData.selectedDate = selcetDate;
        // vm.selectedDate = new Date(selcetDate);
        if (params.length) {
          vm.selectedCompany = params;
          let selected = params[params.length - 1];
          vm.companyName = selected?.name;
          vm.scopeType = selected?.type;
          if (selected.type == 0 || selected.type == 1) {
            vm.companyId = selected.id;
            vm.officeId = "";
          } else if (selected.type == 2) {
            vm.companyId = "";
            vm.officeId = selected.id;
          }
          vm.currentPage = 1;
          vm.dailyList = [];
          vm.onRefresh();
        }
      });
    } else {
      next();
    }
  },
  async activated() {
    // this.dateType = this.$route.query?.type == "天" ? "day" : "month";
    // this.selectedDate = new Date(this.$route.query.date);
    // this.currentDate = this.$route.query.date;
    // const user = (await VeiBanBridge.getUserInfo()) || {};
    // this.companyId = this.companyId ? this.companyId : user?.companyId;
    // this.companyName = this.companyName ? this.companyName : user?.companyName;
    // if (this.dateType === "day") {
    //   // this.currentDate = this.getCurrentDay(new Date());
    //   this.currentDate = this.$route.query.date
    // } else {
    //   // this.currentDate = this.getCurrentMonth(new Date());
    //   this.currentDate = this.$route.query.date
    // }
    // this.getYesterday();
    // this.dailyInfo = this.$route?.query;
    this.getOverviewData();
    // this.currentPage = 1;
    // this.dailyList = [];
  },
  async created() {
    this.dateType = this.$route.query?.type == "天" ? "day" : "month";
    this.selectedDate = new Date(this.$route.query.date);
    this.currentDate = this.$route.query.date;
    // const user = (await VeiBanBridge.getUserInfo()) || {};
    // this.companyId = this.companyId ? this.companyId : user?.companyId;
    // this.companyName = this.companyName ? this.companyName : user?.companyName;
    // if (this.dateType === "day") {
    //   // this.currentDate = this.getCurrentDay(new Date());
    //   this.currentDate = this.$route.query.date
    // } else {
    //   // this.currentDate = this.getCurrentMonth(new Date());
    //   this.currentDate = this.$route.query.date
    // }
    // this.getYesterday();
    // this.dailyInfo = this.$route?.query;
    this.getOverviewData();
  },
};
</script>

<style scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  padding-top: 246.48px;
  background: #f9f9f9;
  position: relative;
}
.header {
  position: fixed;
  width: 100%;
  height: 246.48px;
  background: inherit;
  top: 0;
  left: 0;
  z-index: 99;
}
.daily_tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}

.company_selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}
.daily_tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.search_tab {
  width: 9rem;
  height: 1rem;
  margin: 10px auto;
  display: flex;
  background-color: #ffffff;
}
.search_tab div {
  width: 25%;
  height: 100%;
  line-height: 1rem;
  text-align: center;
  font-family: Source Han Sans CN;
  color: #1584ff;
  font-size: 14px;
}
.active {
  background-color: #1584ff;
  color: #ffffff !important;
  border: none !important;
}
.daily_content {
  width: 100%;
  background-color: #ffffff;
}
.report_search {
  height: 1.2rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 0.2rem;
  background-color: #ffffff;
}
.end_date {
  font-family: Source Han Sans CN;
  color: #999999;
  font-size: 12px;
}
.show_Statistic {
  padding-top: 10px;
  padding-left: 16px;
  display: flex;
  justify-content: space-between;
}

.member_img {
  width: 1rem;
  height: 1rem;
  margin-right: 8px;
  border-radius: 0.21rem;
}
.van-cell__value {
  position: relative;
}
.van-search {
  background: #f7f8fa;
}
.van-search .van-cell {
  background: #ffffff;
  height: 34px;
}
</style>
